import React from 'react';

import { Text } from '~/components/core';
import type { CoveredEntityWithParticipationsResponseCoverageParticipationForFESchema as CoverageParticipation } from '~/server_shared/openapi/data-contracts';
import cn from '~/Utils/cn';

const COVERAGE_PARTICIPATIONS_COLUMNS = [
  {
    id: 'carrier_name',
    label: 'Carrier Name',
    displayValue: (participation) => participation.carrier_name,
  },
  {
    id: 'slot_name',
    label: 'Slot Name',
    displayValue: (participation) => participation.slot_name,
  },
  {
    id: 'allocation_percentage',
    label: 'Percentage',
    displayValue: (participation) => `${parseFloat(participation.allocation_percentage)}%`,
  },
] as const satisfies {
  id: string;
  label: string;
  displayValue: (participation: CoverageParticipation) => string;
}[];

const CoverageParticipationsExpandedRow = ({ participations }: { participations: CoverageParticipation[] }) => {
  return (
    <div className="grid grid-cols-[auto_auto_auto] gap-x-24 gap-y-12" role="table">
      <div role="row" className="contents">
        {COVERAGE_PARTICIPATIONS_COLUMNS.map((column) => (
          <div
            key={column.id}
            role="columnheader"
            className={cn('-mb-4', { 'text-end': column.id === 'allocation_percentage' })}
          >
            <Text
              key={column.id}
              variant={Text.VARIANTS.XS}
              colorVariant={Text.COLOR_VARIANTS.DISABLED}
              weight={Text.WEIGHTS.SEMI_BOLD}
            >
              {column.label}
            </Text>
          </div>
        ))}
      </div>
      {participations.map((participation) => (
        <div key={participation.external_id} role="row" className="contents">
          {COVERAGE_PARTICIPATIONS_COLUMNS.map((column) => (
            <div
              key={`${participation.external_id}-${column.id}`}
              role="cell"
              className={cn({ 'text-end': column.id === 'allocation_percentage' })}
            >
              <Text
                key={`${participation.external_id}-${column.id}`}
                variant={Text.VARIANTS.SM}
                colorVariant={participation.is_lead ? Text.COLOR_VARIANTS.PRIMARY : Text.COLOR_VARIANTS.SECONDARY}
                weight={participation.is_lead ? Text.WEIGHTS.SEMI_BOLD : Text.WEIGHTS.MEDIUM}
              >
                {column.displayValue(participation)}
              </Text>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default CoverageParticipationsExpandedRow;
